/* eslint-disable no-loop-func */
import { createSlice } from "@reduxjs/toolkit";
import { deepMerge } from "../utils/helper";
import qs from "qs";

const init = {
  isEnabledEmail: false,
  isEnabledOrderId: false,
  isEnabledPhoneNumber: false,
  isEnabledTrackingNumber: false,
  general: {
    width: 100,
    show: ["progress_bar", "order_detail", "tracking_logs", "map"],
    dateFormat: "D MMM YYYY",
    timeFormat: "HH:mm a",
    theme: 1,
    buttonColor: "#f2b705",
    textColor: "#000000",
  },
  trackingForm: {
    showMethods: "both",
    requireEmail: false,
    requireOrderId: false,
    requirePhoneNumber: false,
    requireTrackingNumber: false,
  },
  progressBar: {
    color: "#C5E85D",
  },
  trackingStatus: {
    pending: "Pending",
    ordered: "Ordered",
    information_received: "Order ready",
    in_transit: "In Transit",
    out_for_delivery: "Out For Delivery",
    delivered: "Delivered",
    courier_not_supported: "NO INFO",
    expired: "Expired",
    failed_attempt: "Failed Attempt",
    exception: "Delivery failed",
  },
  customStatus: {
    enabled: false,
    label: "Order packed",
    icon: 1,
    timeActive: "2",
  },
  displayStatusBar: ["Ordered", "Order Ready", "Delivered", "Out for delivery"],
  productRecommend: {
    title: "Recommend Products",
    active: "none",
  },
  mappingCourier: {
    couriers: [{ from: "", to: "" }],
  },
  customMessage: {
    replaceMessage: "",
    trackingUrl: {
      isActive: false,
      description: "",
    },
  },
  footerLinks: {
    social: {
      facebook: "",
      twitter: "",
    },
    policy: {
      privacyPage: "",
      returnPage: "",
      termPage: "",
      support: "",
    },
  },
  additional: {
    textAbove: "",
    textBelow: "",
    htmlTop: "",
    htmlBottom: "",
    customCss: "",
  },
  i18n: {
    tracking_form: {
      title: "Track your order",
      order_id: "Order ID",
      email: "Email",
      or: "OR",
      tracking_number: "Tracking Number",
      button: "Track",
      plh_order_id: "Enter your order name",
      plh_email: "Enter your email",
      plh_tracking_number: "Enter your tracking number",
      order_not_found: "Order not found",
    },
    tracking_history: {
      shipment_information: "Shipment Information",
      shipping_address: "Shipping address",
      tracking_number: "Tracking number",
      shipment_history: "Shipment history",
      carrier: "Carrier",
    },
    progress_bar: {
      status: "Status",
    },
    order_details: {
      shipment_items: "Items of shipment",
      product: "Products",
      total_price: "Total",
      item_singular: "item",
      item_plural: "items",
    },
    review: {
      button_text: "Review us",
      review_title: "Your satisfaction is Our Biggest Rewards",
    },
    footer: {
      privacy: "Privacy",
      return: "Return",
      supportt: "Support",
      term: "Term",
    },
  },
  time_zone: "",
};

const param = qs.stringify(init);
const json = qs.parse(param);

// console.log("params", window.dynamicReview);
// console.log(json);
export const settingsSlice = createSlice({
  name: "settings",
  initialState: init,
  reducers: {
    setSettings: (state, action) => {
      let settings;
      settings = action.payload;
      // if (typeof action.payload === "string") {
      //   settings = JSON.parse(action.payload);
      // } else {
      //   settings = action.payload;
      // }
      // settings.general.show = settings.general.show.split(",");
      settings.displayStatusBar =
        typeof settings.displayStatusBar === "object"
          ? settings.displayStatusBar
          : settings.displayStatusBar.split(",");
      settings.reviewQuestions =
        typeof settings.reviewQuestions === "string"
          ? JSON.parse(settings.reviewQuestions)
          : settings.reviewQuestions;
      return deepMerge(
        state,
        window.dynamicReview ? window.dynamicReview : settings
      );
      // return { ...state, ...settings };
    },
    setI18nSettings: (state, action) => {
      return {
        ...state,
        i18n: action.payload,
        trackingStatus: action.payload?.tracking_status,
      };
    },
    overrideSettings: (state, action) => {
      return deepMerge(state, action.payload);
    },
    setTimeZone: (state, action) => {
      return {
        ...state,
        time_zone: action.payload,
      };
    },
  },
});

export const { setSettings, overrideSettings, setTimeZone, setI18nSettings } =
  settingsSlice.actions;
export default settingsSlice.reducer;
